'use client';

import { useState } from 'react';
import PolicyList from '@/af_components/AssemblyFilter';
import Link from 'next/link';
import CommitteeList from './CommitteeFilter';

interface Policy {
  id: string;
  title: string;
  slug: string;
  vote_count: number;
  description: string;
  paragraphContent?: string;
  paragraphTranslation?: string;
  category: string;
  status: string;
  created_at: string;
  created_by: string;
  author: {
    id: string;
    username: string;
    imageUrl: string;
    slug: string;
  };
  voteStats: {
    userVote: string | null;
  };
}

interface HomePageClientProps {
  policiesWithData: Policy[];
  userId: string | null;
  headerTitle?: string;
  defaultCommitteeSlug?: string;
  defaultCommitteeName?: string;
}

export default function CommitteePageClient({ policiesWithData, userId, headerTitle, defaultCommitteeSlug, defaultCommitteeName }: HomePageClientProps) {
  const [language, setLanguage] = useState<'english' | 'american'>('english');

  // Map policies to show appropriate language version
  const displayedPolicies = policiesWithData.map(policy => ({
    ...policy,
  
  }));

  return (
    <main className="w-full min-h-screen text-black bg-amber-50">
      <div className="max-w-3xl mx-auto p-8">
        <h1 className="text-3xl tracking-tight font-extrabold text-gray-900  text-black font-bold mb-3 font-serif tracking-tight border-bf border-amber-200 pb-4">
          <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3'>
            <span className="mr-1">
              {headerTitle || 'America First Assembly'}
            </span>
            {defaultCommitteeName ? (
              <span className="rounded-full border border-amber-300 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-amber-800 bg-amber-50">
                Committee: {defaultCommitteeName}
              </span>
            ) : null}
          </div>
        </h1>

        <CommitteeList initialPolicies={displayedPolicies || []} userId={userId} language={language} setLanguage={setLanguage} defaultCommitteeName={defaultCommitteeName} defaultCommitteeSlug={defaultCommitteeSlug} />
      </div>
    </main>
  );
}
